import { ENV } from "./env";

export const resumenPlanHogarFlexPdf = `${ENV.PUBLIC_URL}/files/Resumen informativo personalizado.pdf`;
export const terminosYCondicionesHogarFlexPdf = `${ENV.PUBLIC_URL}/files/coberturas_personalizado.pdf`;
export const enCasoDeSiniestroPdf = `${ENV.PUBLIC_URL}/files/En caso de siniestro hogar flex.pdf`;
export const exclusionesPdf = `${ENV.PUBLIC_URL}/files/Exclusiones hogar flex.pdf`;
